export default interface FormFieldSetting {
    formField: FormField,
    name: string,
    isVisible: boolean,
    isVisibilityConfigurable: boolean,
    isEditable: boolean,
    isEditabilityConfigurable: boolean,
    isNotificationEnabled: boolean,
    isNotificationSettingConfigurable: boolean,
    rule?: any;
};

export function getSetting(formFieldSettings: FormFieldSetting[], formField: FormField): FormFieldSetting | undefined {
    return formFieldSettings.find(setting => setting.formField === formField);
}

export enum FormField {
    CustomerAccount = 1,
    ContractLocation,
    InventoryLocation,
    Region,
    DeliveryPeriod,
    StartDate,
    EndDate,
    CropYear,
    Symbol,
    SymbolMonth,
    Basis,
    DeliveryMethod,
    FuturesPrice,
    CashPrice,
    FinalPrice,
    Quantity,
    ExpirationDate,
    Trader,
    PaymentOption,
    Comment,
    HTAFee,
    FreightFee,
    TotalFees,
    CustomerContractId,
    DeliveryTerms,
    PriceAtOpen,
    DeferPayInterestRate,
    SendNotificationToCustomer,
    DeliveryLocation,
    ErpContractId
}